import { render, staticRenderFns } from "./BtnDownload.vue?vue&type=template&id=5b599556&"
import script from "./BtnDownload.vue?vue&type=script&lang=ts&"
export * from "./BtnDownload.vue?vue&type=script&lang=ts&"
import style0 from "./BtnDownload.vue?vue&type=style&index=0&id=5b599556&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports